import EnhancedForm from 'components/enhanced/form/EnhancedForm';
import { AutocompleteAdapter } from 'components/enhanced/form/adapters/selects/AutocompleteAdapter';
import { IdentityField } from 'components/enhanced/form/fields/IdentityField';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { locationService } from 'shared/services';
import { Option } from 'shared/types/general';
import toast from 'shared/utils/toast';

interface AssignProductToLocationFormProps {
  productId: number;
  warehouses: Option[];
  callback?: any;
}

export const AssignProductToLocationForm = ({
  productId,
  warehouses,
  callback
}: AssignProductToLocationFormProps) => {
  const { t } = useTranslation();

  const [locations, setLocations] = useState<Option[]>([]);
  const [warehouse, setWarehouse] = useState<Option | null>(null);
  const [location, setLocation] = useState<Option | null>(null);

  useEffect(() => {
    if (warehouse) {
      locationService.getAllBaseInformation({ warehouse_id: warehouse.id }).then((res) => {
        setLocations(res);
      });
    } else {
      setLocation(null);
      setLocations([]);
    }
  }, [warehouse]);

  const onSubmit = (e) => {
    locationService.assignProduct(location.id, productId).then(() => {
      toast.success('Piazza aggiunta con successo.');
      if (callback) {
        callback();
      }
    });
  };

  return (
    <EnhancedForm onSubmit={onSubmit} autoStyleLayout columns={1}>
      {warehouses && (
        <IdentityField
          name="warehouse"
          component={AutocompleteAdapter}
          initValue={warehouse}
          defaultValue={warehouse}
          setValue={setWarehouse}
          options={warehouses}
          label={t('global.warehouse')}
          type="text"
        />
      )}
      {locations && (
        <IdentityField
          name="locations"
          component={AutocompleteAdapter}
          initValue={locations}
          defaultValue={locations}
          options={locations}
          setValue={setLocation}
          label={t('global.location')}
          type="text"
        />
      )}
    </EnhancedForm>
  );
};
